<template>
    <section>
        <div class="container">
            <div class="row justify-center">
                <div class="col-xs-12 col-md-7">
                    <div class="text-title">Account Email Verification</div>
                    <q-card v-if="email" style="min-height: 300px;">
                        <q-card-section v-if="confirmed && !confirmEmailPending" class="text-center q-pa-xl">
                            <div class="text-subtitle row items-center justify-center">
                                Your email has been confirmed!
                            </div>
                            <div class="text-subtitle1 q-py-md row items-center justify-center">
                                <q-icon name="mdi-email-check-outline" size="4em" color="positive" />
                            </div>
                            <p>You can now sign in to the website by clicking the button below.</p>
                            <div class="q-pb-md row items-center justify-center">
                                <q-btn @click="showLogin = true"
                                       color="primary" label="Sign In" icon="mdi-account-arrow-right" />
                            </div>
                        </q-card-section>

                        <q-card-section v-else-if="!confirmEmailPending" class="text-center q-pa-xl">
                            <div class="text-subtitle row items-center justify-center">
                                Please confirm your email address.
                            </div>
                            <div class="text-subtitle1 q-py-md row items-center justify-center">
                                <q-icon name="mdi-email-outline" size="4em" color="primary" />
                            </div>
                            <p>We sent an email to <span class="text-weight-medium">{{ email }}</span>. Please check your Inbox and find the confirmation email we've sent you to complete your registration. If you cannot find the email within your Inbox, please check your Spam folder. It may take up to 10 minutes to recieve this email.</p>
                            <span class="text-subtitle2">Didn't receive the email?</span>
                            <div class="q-mt-xs q-pb-md row items-center justify-center">
                                <q-btn @click="resendEmail" color="primary" label="Send it again" icon="mdi-email-send" outline :loading="resendConfirmEmailPending" />
                            </div>
                        </q-card-section>
                        <q-inner-loading :showing="confirmEmailPending">
                            <div>
                                <q-spinner color="primary"
                                           :thickness="2"
                                           size="3em" />
                            </div>
                        </q-inner-loading>
                    </q-card>
                </div>
            </div>
        </div>
        <q-dialog v-model="showLogin">
            <login @close="showLogin = false;" :returnUrl="returnUrl" style="width: 100%; max-width: 375px;" />
        </q-dialog>
    </section>
</template>
<script>
    import { mapState } from 'vuex'
    import login from '@/components/Login'
    export default {
        name: 'confirm-email',
        components: {
            login,
        },
        data() {
            return {
                returnUrl: '',
                showLogin: false,
                userId: null,
                token: null,
                email: '',
                confirmed: false,
                error: false,
            }
        },
        methods: {
            resendEmail() {
                if (this.email)
                    this.$store.dispatch('resendConfirmEmail', { email: this.email }).then(() => {
                        this.$q.notify({
                            badgeClass: 'hidden',
                            type: 'positive',
                            message: 'Confirmation email sent'
                        })
                    })
            },
            getEmailById(id) {
                if (!id) {
                    this.$router.push('/').catch(err => { })
                    return
                }
                this.$store.dispatch('getEmailById', id).then(() => {
                    this.email = this.getEmailData
                    if (!this.email) {
                        this.$router.push('/').catch(err => { })
                        return
                    }
                    if (!this.userId || !this.token)
                        this.confirmed = false
                    else
                        this.confirmEmail()
                }).catch(err => {
                    this.$router.push('/').catch(err => { })
                }).finally(() => {
                    this.checkConfirm()
                })
            },
            confirmEmail() {
                const payload = { id: this.userId, token: this.token }
                this.$store.dispatch('confirmEmail', payload).then(() => {
                    this.confirmed = true
                })

            },
            checkConfirm() {
                if (!this.confirmed) {
                    this.$store.dispatch('isEmailConfirmed', this.email).then(() => {
                        this.confirmed = this.isEmailConfirmedData
                    }).catch(err => {
                        this.error = true
                    }).finally(() => {
                        if (!this.confirmed && !this.error) setTimeout(() => { this.checkConfirm() }, 10000)
                    })
                }
            }
        },

        computed: {
            ...mapState([
                'confirmEmailPending',
                'confirmEmailData',

                'resendConfirmEmailPending',
                'resendConfirmEmailData',

                'getEmailPending',
                'getEmailData',

                'isEmailConfirmedPending',
                'isEmailConfirmedData',
            ]),
            isLoggedIn() { return this.$store.getters.isLoggedIn },
            user() { return this.$store.getters.authUser },
        },
        created() {
            if (this.isLoggedIn && this.user.emailConfirmed !== 'False') {
                this.$router.push('/').catch(err => { })
                return
            }

            if (this.$route.query.returnUrl)
                this.returnUrl = this.$route.query.returnUrl
            if (this.$route.query.userId)
                this.userId = this.$route.query.userId
            if (this.$route.query.token)
                this.token = encodeURIComponent(this.$route.query.token)

            if (this.isLoggedIn) {
                this.getEmailById(this.user.id)
            }
            else {
                this.getEmailById(this.userId)
            }

        },
        watch: {
            '$route.query.userId'(newVal, oldVal) {
                if (newVal && newVal !== oldVal) {
                    this.userId = newVal
                }
            },
            '$route.query.token'(newVal, oldVal) {
                if (newVal && newVal !== oldVal) {
                    this.token = encodeURIComponent(newVal)
                }
            },
            isLoggedIn(newVal) {
                if (newVal) this.showLogin = false
            },
        },
    }
</script>
